import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { getStageCustomerFeedback } from "redux/memoizedSelectors";
import { ConnectorSource } from "utils/optionsSets/OptionSets";
import { FeedbackConfiguration } from "./feedback-configuration";
import ImportFile from "./import-file";
import { Manual } from "./manual";
import { getAllMapsParams } from "features/comments/helpers";
type Props = {
    customerFeedbackId: string;
    stageId?: string;
    onClose: () => void;

};
export default function DetailFeedBackConfiguration({ customerFeedbackId, stageId, onClose }: Props): JSX.Element {
    const {  personaIdStr, } = getAllMapsParams(useLocation().search);
    const currentItem = useSelector(getStageCustomerFeedback(stageId, personaIdStr))?.getById(customerFeedbackId) || [];
    const connector = useSelector((state:any) => state.settings.connector)?.getById(currentItem?.connectorId);
    const isReadOnly = useSelector(({ auth }: any) => auth.userInfo.UserType)?.isReadOnly();
    const isDisable = isReadOnly || currentItem?.retrieveData  ;//isViewer

    if ([ConnectorSource.Qualtrics, ConnectorSource.SurveyMonkey, ConnectorSource.Sandsiv].includes(connector?.source))
        return <FeedbackConfiguration currentItem={currentItem} isViewer={isDisable} onClose={onClose} />

    switch (currentItem?.source) {
        case ConnectorSource.Manual:
            return <Manual stageId={stageId} feedback={currentItem} isDisable={isDisable} />;
        case ConnectorSource.ImportFile:
            return <ImportFile stageId={stageId} feedback={currentItem} isViewer={isReadOnly} onClose={onClose} />
    }
    return <></>
}